import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <g strokeWidth={1.6}>
      <path
        fill="#0e0f10"
        fillOpacity={0.1}
        d="M16 0c8.864 0 16 7.136 16 16s-7.136 16-16 16S0 24.864 0 16 7.136 0 16 0"
      />
      <path
        fill="#bce4ff"
        d="M16 1.6c7.978 0 14.4 6.422 14.4 14.4S23.978 30.4 16 30.4 1.6 23.978 1.6 16 8.022 1.6 16 1.6"
      />
      <path
        fill="url(#icon-RadioButtonSelected_svg__a)"
        d="M16 1.6c7.978 0 14.4 6.422 14.4 14.4S23.978 30.4 16 30.4 1.6 23.978 1.6 16 8.022 1.6 16 1.6"
      />
      <path
        fill="#bce4ff"
        d="M16 4.8c6.205 0 11.2 4.995 11.2 11.2S22.205 27.2 16 27.2 4.8 22.205 4.8 16 9.795 4.8 16 4.8"
      />
      <path
        fill="#004fd6"
        d="M16 12.8c1.773 0 3.2 1.427 3.2 3.2s-1.427 3.2-3.2 3.2-3.2-1.427-3.2-3.2 1.427-3.2 3.2-3.2"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-RadioButtonSelected_svg__a"
        x1={10}
        x2={10}
        y1={10}
        y2={19}
        gradientTransform="scale(1.6)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0.1} />
        <stop offset={1} stopColor="#0E0F10" stopOpacity={0.05} />
      </linearGradient>
    </defs>
  </svg>
);
const SvgIconRadioButtonSelected = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconRadioButtonSelected);
export default Memo;
